import { userRoles } from '@constants/common';
import { RoutingFlags } from '@constants/routingFlags';

const creditAdminRoles = [
  userRoles.ADMIN,
  userRoles.ADMIN_LITE,
  userRoles.SUPER_ADMIN,
];

export const CreditDashboardRoute = {
  path: '/credit/dashboard',
  load: () => {
    return Promise.all([
      import('./credit-app.css'),
      import('./pages/Dashboard'),
    ]).then(([, module]) => module);
  },
  protected: true,
};

export const OfficeCreditApplicationMetricsRoute = {
  path: '/credit/office-application-metrics',
  load: () => {
    return Promise.all([
      import('./credit-app.css'),
      import('./pages/OfficeCreditApplicationMetrics'),
    ]).then(([, module]) => module);
  },
  routingFlag: RoutingFlags.CreditApp,
  protected: true,
};

export const CreditApplicationsRoute = {
  path: '/credit/applications',
  load: () => {
    return Promise.all([
      import('./credit-app.css'),
      import('./pages/Applications'),
    ]).then(([, module]) => module);
  },
  protected: true,
  roles: creditAdminRoles,
};

export const CreditMyApplicationsRoute = {
  path: '/credit/my-applications',
  load: () => {
    return Promise.all([
      import('./credit-app.css'),
      import('./pages/MyApplications'),
    ]).then(([, module]) => module);
  },
  routingFlag: RoutingFlags.CreditApp,
  protected: true,
};

export const CreditApplicationDetailRoute = {
  path: '/credit/applications/:id',
  load: () => {
    return Promise.all([
      import('./credit-app.css'),
      import('./pages/ApplicationDetail'),
    ]).then(([, module]) => module);
  },
  protected: true,
};

export const CreditQueueRoute = {
  path: '/credit/queue',
  load: () => {
    return Promise.all([
      import('./credit-app.css'),
      import('./pages/Queue'),
    ]).then(([, module]) => module);
  },
  protected: true,
  roles: creditAdminRoles,
};

export const CreditScoringRoute = {
  path: '/credit/scoring',
  load: () => {
    return Promise.all([
      import('./credit-app.css'),
      import('./pages/ScoringAdmin'),
    ]).then(([, module]) => module);
  },
  protected: true,
  routingFlag: RoutingFlags.CreditScoring,
};

export const CreditApplyRoute = {
  path: '/credit/apply',
  load: () => {
    return Promise.all([
      import('./credit-app.css'),
      import('./pages/Apply'),
    ]).then(([, module]) => module);
  },
  protected: false,
  hideLayout: true,
};

export const CreditResumeRoute = {
  path: '/credit/resume',
  load: () => {
    return Promise.all([
      import('./credit-app.css'),
      import('./pages/Resume'),
    ]).then(([, module]) => module);
  },
};

export const CreditSubmittedRoute = {
  path: '/credit/submitted',
  load: () => {
    return Promise.all([
      import('./credit-app.css'),
      import('./pages/Submitted'),
    ]).then(([, module]) => module);
  },
};

export const CreditEmailVerificationRoute = {
  path: '/credit/email-verification/:token',
  load: () => {
    return Promise.all([
      import('./credit-app.css'),
      import('./pages/EmailVerification'),
    ]).then(([, module]) => module);
  },
};
